var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTab = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.75 4a.75.75 0 1 1 1.5 0v8a.75.75 0 0 1-1.5 0V4zM2.25 8A.75.75 0 0 1 3 7.25h5.19L6.97 6.03a.75.75 0 1 1 1.06-1.06l2.488 2.488a.748.748 0 0 1 .012 1.072l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22H3A.75.75 0 0 1 2.25 8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTab);
export default ForwardRef;